import Reflux from 'reflux';
import difference from 'lodash/difference';
import unique from 'lodash/uniq';

import actions from '../actions';
import configurationStore from './configuration-store';
import stateStore from './state-store';
import accessoryStateStore from './accessory-state-store';

export default Reflux.createStore({
	listenables: actions,

	init() {
		this.listenTo(configurationStore, this.onConfigurationChange);
		this.listenTo(stateStore, this.onStateChange);
		this.listenTo(accessoryStateStore, this.onAccessoryStateChange);

		this.state = {
			apiUrl: '',
			languageCode: 'en',
			showDisabled: false,

			items: {
				// configuration
				selectedProperties: [],
				pinnedProperties: [],
				pinningFacetIds: [],
				visibleFacets: [],
				compositions: [],

				// state
				userSelection: {},
				itemListPage: -1
			},

			accessories: {
				// configuration
				selectedProperties: [],
				pinnedProperties: [],
				pinningFacetIds: [],
				visibleFacets: [],
				idsForItems: [],
				compositions: [],

				// state
				userSelection: {},
				itemListPage: -1
			}
		};
	},

	onConfigurationChange(configuration) {
		this.state.apiUrl = configuration.apiUrl;
		this.state.showDisabled = configuration.showDisabled;
		this.state.languageCode = configuration.languageCode;

		// items
		this.state.items.selectedProperties = configuration.selectedProperties || [];
		this.state.items.pinnedProperties = configuration.pinnedProperties || [];
		this.state.items.pinningFacetIds = Object.keys(configuration.preselection || {}).map(a => parseInt(a, 10));
		this.state.items.visibleFacets = configuration.visibleFacets || [];
		this.state.items.compositions = configuration.compositions || [];

		// accessories
		this.state.accessories.selectedProperties = configuration.accessories.selectedProperties || [];
		this.state.accessories.pinnedProperties = configuration.accessories.pinnedProperties || [];
		this.state.accessories.pinningFacetIds = Object.keys(configuration.accessories.preselection || {}).map(a => parseInt(a, 10));
		this.state.accessories.visibleFacets = configuration.accessories.visibleFacets || [];
		this.state.accessories.compositions = configuration.accessories.compositions || [];

		this.output();
	},

	onStateChange(state) {
		this.state.items.userSelection = state.userSelection || {};
		this.state.items.itemListPage = state.itemListPage;
		this.output();
	},

	onAccessoryStateChange(state) {
		this.state.accessories.userSelection = state.userSelection || {};
		this.state.accessories.itemListPage = state.itemListPage;
		this.output();
	},

	onLoadAccessoryIdsForItemsCompleted(data) {
		this.state.accessories.idsForItems = data.body;
		this.output();
	},

	getState() {
		const itemUserSelectedPropertyIds = [];
		const itemUserPinnedPropertyIds = [];
		const itemUserSelection = this.state.items.userSelection;
		Object.keys(itemUserSelection).map((facetId) => {
			facetId = parseInt(facetId, 10);
			if (this.state.items.pinningFacetIds.indexOf(facetId) > -1) {
				itemUserPinnedPropertyIds.push(itemUserSelection[facetId]);
			} else {
				itemUserSelectedPropertyIds.push(itemUserSelection[facetId]);
			}
		});
		const itemSelected = unique(this.state.items.selectedProperties.concat(itemUserSelectedPropertyIds, this.state.items.pinnedProperties));


		const accessoryUserSelectedPropertyIds = [];
		const accessoryUserPinnedPropertyIds = [];
		const accessoryUserSelection = this.state.accessories.userSelection;
		Object.keys(accessoryUserSelection).map((facetId) => {
			facetId = parseInt(facetId, 10);
			if (this.state.accessories.pinningFacetIds.indexOf(facetId) > -1) {
				accessoryUserPinnedPropertyIds.push(accessoryUserSelection[facetId]);
			} else {
				accessoryUserSelectedPropertyIds.push(accessoryUserSelection[facetId]);
			}
		});
		const accessorySelected = unique(this.state.accessories.selectedProperties.concat(accessoryUserSelectedPropertyIds, this.state.accessories.pinnedProperties));

		return {
			userSelection: {
				selected: unique(itemSelected.concat(itemUserPinnedPropertyIds)),
				pinned: unique(this.state.items.pinnedProperties.concat(itemUserPinnedPropertyIds)),
				visible: difference(unique(this.state.items.visibleFacets), this.state.items.pinningFacetIds),
				compositions: this.state.items.compositions
			},
			preselection: {
				selected: itemSelected,
				pinned: this.state.items.pinnedProperties,
				visible: this.state.items.pinningFacetIds
			},
			accessories: {
				selected: unique(accessorySelected.concat(accessoryUserPinnedPropertyIds)),
				pinned: unique(this.state.accessories.pinnedProperties.concat(accessoryUserPinnedPropertyIds)),
				visible: difference(unique(this.state.accessories.visibleFacets), this.state.accessories.pinningFacetIds),
				itemListPage: this.state.accessories.itemListPage,
				itemList: this.state.accessories.idsForItems, // TODO: exclude pinningFacetIds
				compositions: this.state.accessories.compositions
			},
			accessoriesPreselection: {
				selected: accessorySelected,
				pinned: this.state.accessories.pinnedProperties, // TODO: pinnedProperties, pinningFacetIds
				visible: this.state.accessories.pinningFacetIds,
				itemList: this.state.accessories.idsForItems // TODO: exclude pinningFacetIds
			},
			itemListPage: this.state.items.itemListPage,
			apiUrl: this.state.apiUrl,
			languageCode: this.state.languageCode,
			showDisabled: this.state.showDisabled
		};
	},

	output() {
		this.trigger(this.getState());
	},

	getInitialState() {
		return this.getState();
	}
});
